import React from 'react';
import './Layout.css';
import { Header } from '../Header';
import { Footer } from '../Footer';

const Layout = (props) => {
  //const children = this.props.children;
  /**
   * React.Fragment Es para no tener que devolver un div con contenido. React.Fragment no se rendirizará en el DOM
   */
  return (
    <div id="main-container" className="container">
      <Header />
      {props.children}
      <Footer />
    </div>
  );
};
export default Layout;
